/**
 * Persiste todo o perfil relevante para onboarding_pack antes de enfileirar o job.
 * Garante paridade entre formData local e userDoc lido pelo worker.
 */
import { ensureTrainingProfileDefaults } from '../constants/trainingProfileDefaults';
import { flattenGoalTiers } from './trainingGoalTiers';

export function validatePersonalForSync(formData) {
  if (formData.birthDate) {
    const bd = new Date(formData.birthDate);
    if (Number.isNaN(bd.getTime())) {
      throw new Error('Data de nascimento inválida.');
    }
  }
  if (formData.heightCm !== '') {
    const h = parseInt(formData.heightCm, 10);
    if (!Number.isFinite(h) || h < 50 || h > 280) {
      throw new Error('Altura deve estar entre 50 e 280 cm.');
    }
  }
  if (formData.weightKg !== '') {
    const w = parseFloat(formData.weightKg);
    if (!Number.isFinite(w) || w < 20 || w > 400) {
      throw new Error('Peso deve estar entre 20 e 400 kg.');
    }
  }
}

export function buildProfileSyncPayload(formData) {
  validatePersonalForSync(formData);
  const trainingProfile = ensureTrainingProfileDefaults(formData.trainingProfile);
  const trainingGoalTiers = formData.trainingGoalTiers;
  const trainingGoalSlugs = flattenGoalTiers(trainingGoalTiers).length
    ? flattenGoalTiers(trainingGoalTiers)
    : formData.trainingGoalSlugs;

  return {
    name: formData.name,
    heightCm: formData.heightCm === '' ? null : parseInt(formData.heightCm, 10),
    weightKg: formData.weightKg === '' ? null : parseFloat(formData.weightKg),
    birthDate: formData.birthDate || null,
    level: formData.level,
    trainingGoalTiers,
    trainingGoalSlugs,
    physicalState: formData.physicalState,
    trainingInterests: formData.trainingInterests,
    trainingProfile,
    previousTrainingBase: formData.previousTrainingBase || '',
  };
}

export async function syncProfileBeforeOnboarding({ formData, updateUser }) {
  const payload = buildProfileSyncPayload(formData);
  await updateUser(payload);
}
